import React, { Fragment } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { FormikTextField } from '../shared/form/formik/FormikTextField'
import { FormikRadioGroup } from '../shared/form/formik/FormikRadioGroup'
import { BankPaymentAccountType } from './BankPaymentForm.constants'
import { useFormikContext } from 'formik'
import { InfoContainer } from '../shared/InfoContainer'

interface BankInformationContentProps {
  businessEntityStepCompleted?: boolean
  handleChange: (e: React.ChangeEvent<any>) => void
}

const ACCOUNT_NUMBER_MASK = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]

const paymentAccountOptions = [
  { label: 'Checking', value: BankPaymentAccountType.CHECKING },
  { label: 'Savings', value: BankPaymentAccountType.SAVINGS },
]

export const BankInformationContent = ({
  handleChange,
  businessEntityStepCompleted = false,
}: BankInformationContentProps) => {
  const { values } = useFormikContext<any>()

  const hasPrefilledName = !!values.nameOnCard

  return (
    <Fragment>
      {!businessEntityStepCompleted && (
        <Fragment>
          <InfoContainer className={tw`mb-4 rounded-2xl p-0 py-3 px-4`} useInfoIcon>
            Please provide an Individual Bank Account. To use a Business Account, add your business
            entity details. Contact support if you need help.
          </InfoContainer>
          <div css={tw`mb-4`}>
            <FormikTextField
              name="nameOnCard"
              placeholder="Enter name on account"
              label="Full name"
              onChange={handleChange}
              disabled={hasPrefilledName}
              css={tw`w-full`}
              inputProps={{ 'data-testid': 'payments-bank-account-name-input' }}
            />
            {hasPrefilledName && (
              <div
                css={tw`mt-2 p-3 flex flex-row items-center rounded-2xl bg-[var(--mui-shades-100)]`}
              >
                <div
                  css={tw`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mr-3 bg-[#4A3F57]`}
                >
                  <Typography css={tw`text-white text-xs font-bold`}>i</Typography>
                </div>
                <div css={tw`flex flex-col`}>
                  <Typography css={tw`text-sm text-[#4A3F57]`}>
                    Full name is prefilled with your verified legal name and can't be edited.
                    Contact support if you need help.
                  </Typography>
                </div>
              </div>
            )}
          </div>
        </Fragment>
      )}
      <div css={tw`mb-4`}>
        <FormikTextField
          name="routingNumber"
          placeholder="Enter routing number"
          label="Routing number"
          onChange={handleChange}
          css={tw`w-full`}
          inputProps={{ 'data-testid': 'payments-bank-routing-input' }}
        />
      </div>
      <div css={tw`mb-4`}>
        <FormikTextField
          name="accountNumber"
          placeholder="Enter account number"
          label="Account number"
          mask={ACCOUNT_NUMBER_MASK}
          onChange={handleChange}
          css={tw`w-full`}
          inputProps={{ 'data-testid': 'payments-bank-account-number-input' }}
        />
      </div>
      <div>
        <FormikRadioGroup
          label="Select preferable option"
          name="accountType"
          options={paymentAccountOptions}
          onChange={handleChange}
          dataTestId="payments-bank-account-type-input"
        />
      </div>
    </Fragment>
  )
}
